export default "__VITE_ASSET__DZZghdrz__"